export const linkButtonClicked = (href, linkText, headerText = '') => ({
  type: 'Link Button Clicked',
  data: {
    url: href,
    link_text: linkText,
    component_heading: headerText,
  },
});
